export enum DISCLAIMER_ASSET_KEYS {
  LEFT_ARROW = 'LEFT_ARROW',
  ATTENTION_ICON = 'ATTENTION_ICON',
}

export type DisclaimerAssests = Record<DISCLAIMER_ASSET_KEYS, unknown>;
